import {jarallax} from 'jarallax';

$(function () {
    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.7,
    });
})

